import React from 'react';
import { Link } from 'react-router-dom';
import './AgentCard.css';

const AgentCard = ({ title, description, path, live, isDetailViewEnabled }) => {
  return (
    <div className="agent-card">
      {live && (
        <span className="live-badge" title="Live">
          Live
        </span>
      )}
      <h3 className="agent-card-title">{title}</h3>
      <p dangerouslySetInnerHTML={{ __html: description }}></p>
      {/* <Link to={path} className="agent-card-button"> */}
      <Link to={path} className={`agent-card-button ${!isDetailViewEnabled ? 'disabled' : ''}`}>
        View Details
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="arrow-icon"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </Link>
    </div>
  );
};

export default AgentCard;